import PieChart from './PieChart';
import UIBuilder from '../BaseComponent';
import { UI_COMPONENTS_TYPE_FIELD } from '../../../../Constant/Constant';

export default class PieChartBuilder extends UIBuilder {
  constructor() {
    super();
    this.schema = {
      data: UI_COMPONENTS_TYPE_FIELD.JSON,
    };
  }

  getType = () => {
    return 'pie_chart';
  };

  getComponent = () => {
    return PieChart;
  };
}
